import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}
export function Modal({
  isOpen,
  onClose,
  children,
  title,
  maxWidth = 'lg'
}: ModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl'
  };
  return createPortal(<div className="fixed inset-0 z-[9999] flex items-center justify-center" data-id="element-2356">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-2357" />

      {/* Modal */}
      <div className={`relative w-full ${maxWidthClasses[maxWidth]} mx-4 max-h-[80vh] glass-border rounded-xl shadow-2xl overflow-hidden flex flex-col`} data-id="element-2358">
        {/* Header */}
        {title && <div className="flex items-center justify-between px-6 py-4 border-b border-border-subtle shrink-0" data-id="element-2359">
            <h2 className="text-lg font-semibold text-text-primary" data-id="element-2360">{title}</h2>
            <button onClick={onClose} className="p-1 hover:bg-background-secondary rounded transition-colors text-text-secondary hover:text-text-primary" data-id="element-2361">
              <X size={20} data-id="element-2362" />
            </button>
          </div>}

        {/* Close button (if no title) */}
        {!title && <button onClick={onClose} className="absolute top-4 right-4 p-1 hover:bg-background-secondary rounded transition-colors text-text-secondary hover:text-text-primary z-10" data-id="element-2363">
            <X size={20} data-id="element-2364" />
          </button>}

        {/* Content */}
        <div className="overflow-y-auto flex-1" data-id="element-2365">{children}</div>
      </div>
    </div>, document.body);
}